import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Llegás al domingo a las 9 de la noche con el Word en blanco — y la planificación tiene que estar lista para mañana.', 'Diseñás rúbricas y evaluaciones desde cero cada vez — sabés qué evaluar, pero no tenés tiempo para escribirlo bien.', 'Los informes pedagógicos se acumulan como una deuda — cada fin de trimestre es una maratón que consume tus noches.', 'Los alumnos llegan desenganchados — sabés que podrías hacer algo mejor, pero el tiempo de diseño te consume.', 'Tenés alumnos con necesidades específicas sin PPI documentado — una carga más sobre tu consciencia profesional.', 'Las familias te escriben a las 11 de la noche — no sabés cómo responder sin escalar el conflicto.'];
export function PainPointsSection() {
  return <section className="py-8 md:py-16 px-4 bg-brand-dark" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <h2 className="text-3xl md:text-4xl font-black text-center text-white mb-8 md:mb-10" data-id="element-190">
          ❌ ¿Te pasa alguna de estas cosas?
        </h2>

        <div className="space-y-3 md:space-y-5 mb-6 md:mb-10 bg-red-900/20 p-5 md:p-8 rounded-2xl border border-red-500/20" data-id="element-191">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-192">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-193" />
              <p className="text-xl font-medium text-gray-200" data-id="element-194">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-195">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 md:mb-6" data-id="element-196">
            🔥 ¡QUIERO DEJAR DE PERDER FINES DE SEMANA Y TENER TODO RESUELTO!
          </h3>
          <div className="max-w-xl mx-auto" data-id="element-197">
            <CTAButton text="🚀 ¡ACCEDÉ AL SISTEMA AHORA!" href="#compra" data-id="element-198" />
          </div>
        </div>
      </div>
    </section>;
}